import React from 'react';
import SideBar from '../../SideBar';
import HeaderSection from '../../HeaderSection';
import { Link } from 'react-router-dom';
import '../../../../assets/css/app-testimonials-module.css';
import '../../../../assets/css/loader.css';   

export default function WishlistWhatsTestimonials() { 

    return (
        <>
            <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        <div className="google-reviews-saction-one">
                            <div className="google-left-one">
                                <h2>Testimonials Slider</h2>
                                <ul>
                                    <li><Link to="/customer/apps/testimonials"><img src={`${process.env.PUBLIC_URL}/images/icon-1.png`} alt="icon-1" />Widget</Link></li>
                                    <li><Link to="/customer/apps/testimonials/wishlist" className="active"><img src={`${process.env.PUBLIC_URL}/images/icon-2.png`} alt="icon-2.png" />Request a Feature</Link></li>
                                    <li><Link to="/customer/apps/testimonials/whats-new"><img src={`${process.env.PUBLIC_URL}/images/icon-3.png`} alt="icon-3" />What’s New</Link></li>
                                </ul>
                            </div>
                            {/*<div className="google-right-one">
                                <div className="views-box">
                                    <div className="widgets-left">
                                        <p>Widgets <span>9/9</span></p>
                                    </div>
                                    <div className="views-right">
                                        <p>Views</p>
                                        <span>155/50,000</span>
                                        <div className="baar-progress"></div>
                                        <h6>Resets on Feb 10</h6>
                                    </div>
                                </div>
                            </div>*/}
                        </div>
                        <div className="google-reviews-saction-tow">
                            <div className="request-any-row">
                                <div className="request-any-row-left">
                                    <h2>Request any feature you want in Google Reviews</h2>
                                    <p>Your ideas are the backbone of our service improvement. Share your desired features and make a direct impact on the development of the widget you love. We're all ears!</p>
                                </div>
                                <div className="request-any-row-right">
                                    <Link to="#">Request a Feature</Link>
                                </div>
                            </div>

                            <div className="request-any-row-tow">
                                <h2>Vote for the features you want to see next!</h2>
                                <div className="row">
                                <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <span>Trending</span>
                                        <div className="request-any-row-tow-box">
                                            <div className="vot-rating-left"><span>182</span></div>
                                            <div className="vot-user-right"><img src={`${process.env.PUBLIC_URL}/images/icon-15.png`} alt="icon-15" /></div>
                                            <p>Clients can leave their reviews by click on the Write a review button, no redirect to Google</p>
                                            <ul div className="replay-view">replay
                                                <li><img src={`${process.env.PUBLIC_URL}/images/replay.png`} alt="replay" />18 Replies</li>
                                                <li><img src={`${process.env.PUBLIC_URL}/images/view.png`} alt="view" />532 Views</li>
                                            </ul>
                                            <Link to="#"><img src={`${process.env.PUBLIC_URL}/images/vote.png`} alt="vote" />Vote</Link>
                                        </div>
                                    </div>

                                </div>
                                <div className="see-all-feature-requests-button"><Link to="#">See All Feature Requests</Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}